import Vue from 'vue';
import App from './App.vue';
import store from './store';
import security from './security';

import './assets/scss/main.scss';

Vue.config.productionTip = false;

Vue.prototype.$security = security;

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
